export const ALIGN_CENTER = 'CENTER';
